import React from 'react';
import type { ClosingPackageModalKind } from '../../workspace/closingPackageModalKinds';
import ClosingPackageClientApprovalModal from './ClosingPackageClientApprovalModal';
import ClosingPackageClientReceiptModal from './ClosingPackageClientReceiptModal';
import ClosingPackageFormationModal from './ClosingPackageFormationModal';
import ClosingPackagePrepareOriginalsModal from './ClosingPackagePrepareOriginalsModal';
import ClosingPackageRevisionModal from './ClosingPackageRevisionModal';
import ClosingPackageSendOriginalsModal from './ClosingPackageSendOriginalsModal';
import ClosingPackageSendViaEdoModal from './ClosingPackageSendViaEdoModal';
import ClosingPackageConfirmEdoReceiptModal from './ClosingPackageConfirmEdoReceiptModal';
import ClosingPackageSendScansModal from './ClosingPackageSendScansModal';

export type ClosingPackageTaskModalHostProps = {
  open: boolean;
  onClose: () => void;
  onSuccess?: () => void | Promise<void>;
  applicationId: number;
  taskType: string;
  modalKind: ClosingPackageModalKind;
};

/**
 * Routes Closing Package workspace modal kind → shell component (IMP-001H-1).
 */
const ClosingPackageTaskModalHost: React.FC<ClosingPackageTaskModalHostProps> = ({
  open,
  onClose,
  onSuccess,
  applicationId,
  taskType,
  modalKind,
}) => {
  const common = { open, onClose, applicationId, taskType };

  switch (modalKind) {
    case 'formation':
      return <ClosingPackageFormationModal {...common} onSuccess={onSuccess} />;
    case 'send-scans':
      return <ClosingPackageSendScansModal {...common} onSuccess={onSuccess} />;
    case 'client-approval':
      return <ClosingPackageClientApprovalModal {...common} onSuccess={onSuccess} />;
    case 'revision':
      return <ClosingPackageRevisionModal {...common} onSuccess={onSuccess} />;
    case 'prepare-originals':
      return <ClosingPackagePrepareOriginalsModal {...common} onSuccess={onSuccess} />;
    case 'send-originals':
      return <ClosingPackageSendOriginalsModal {...common} onSuccess={onSuccess} />;
    case 'send-via-edo':
      return <ClosingPackageSendViaEdoModal {...common} onSuccess={onSuccess} />;
    case 'client-receipt':
      return <ClosingPackageClientReceiptModal {...common} onSuccess={onSuccess} />;
    case 'confirm-edo-receipt':
      return <ClosingPackageConfirmEdoReceiptModal {...common} onSuccess={onSuccess} />;
    default:
      return null;
  }
};

export default ClosingPackageTaskModalHost;
